import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'subpage.stress.unlock.heading',
		defaultMessage: "Get the relief you've been waiting for.",
		description: 'Heading for the stress category page unlock section',
	},
	body: {
		id: 'subpage.stress.unlock.body',
		defaultMessage: 'Choose from an extensive catalog, from 2-minute breathing exercises to 7-day programs.',
		description: 'Body text for the stress category page unlock section',
	},
});
